import * as React from "react";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { Visibility } from "@mui/icons-material";

function not(a, b) {
    return a.filter((value) => !b.includes(value));
}

function intersection(a, b) {
    return a.filter((value) => b.includes(value));
}

export default function TransferList({ disabled, shippers, selectedShippers, shipper, onChange }) {
    const [checked, setChecked] = React.useState([]);
    const [left, setLeft] = React.useState(shippers);
    const [right, setRight] = React.useState([]);
    const [selected, setSelected] = React.useState([]);

    const not = (a = [], b = []) => {
        return a.filter((itemA) => !b.some((itemB) => itemB.id === itemA.id));
    };

    React.useEffect(() => {
        // garante arrays
        const shippersArr = Array.isArray(shippers) ? shippers : [];

        const selectedIds = (() => {
            if (!Array.isArray(selectedShippers)) return [];
            return selectedShippers.length > 0 && Array.isArray(selectedShippers[0])
            ? selectedShippers[0]
            : selectedShippers;
        })();

        // se selectedShippers for array de ids -> encontrar os objetos correspondentes em shippers
        const selected = selectedIds.length
            ? shippersArr.filter((s) =>
                selectedIds.some((id) => String(id) === String(s.id))
            )
            : [];

        // Determina se há um shipper principal válido para remover das listas
        const shipperIdToRemove = shipper?.id || shipper;
        const hasValidShipperToRemove = shipperIdToRemove && shipperIdToRemove !== "0";

        const filteredShippers = hasValidShipperToRemove
            ? shippersArr.filter(s => String(s.id) !== String(shipperIdToRemove))
            : shippersArr;

        const filteredSelected = hasValidShipperToRemove
            ? selected.filter(s => String(s.id) !== String(shipperIdToRemove))
            : selected;

        const leftOnly = not(filteredShippers, filteredSelected);

        setLeft(leftOnly);
        setRight(filteredSelected);

        // CORREÇÃO: Se o shipper principal estava na lista de selecionados e foi
        // removido automaticamente, notificar o pai para manter o estado sincronizado.
        // Isso evita que o shipper "desapareça" silenciosamente dos affiliates quando
        // o usuário interagir com a lista depois.
        const shipperWasInSelected = hasValidShipperToRemove &&
            selected.some(s => String(s.id) === String(shipperIdToRemove));

        if (typeof onChange === "function" && shipperWasInSelected) {
            onChange(filteredSelected.map((s) => s.id));
        }

        // limpar seleção quando a lista muda
        setChecked([]);
    }, [shippers, selectedShippers, shipper]);

    // React.useEffect(() => {
    //     if (typeof onChange === "function" && right.length > 0 ) {
    //         onChange(right.map((shipper) => shipper.id) );
    //     }
    // }, [right]);

    // const leftChecked = intersection(checked, left);
    // const rightChecked = intersection(checked, right);
    const leftChecked = intersection(selected, left);
    const rightChecked = intersection(selected, right);

    // const handleToggle = (value) => () => {
    //     const currentIndex = checked.indexOf(value);
    //     const newChecked = [...checked];

    //     if (currentIndex === -1) {
    //     newChecked.push(value);
    //     } else {
    //     newChecked.splice(currentIndex, 1);
    //     }

    //     setChecked(newChecked);
    // };

    const customList = (items) => (
        <Paper sx={{ minWidth: 210, height: 150, overflow: "auto" }}>
            <List 
                disabled={disabled}
                component="div"
                role="list"
            >
                {items.map((value, index) => {
                    const labelId = `transfer-list-item-${value.id}-label`;
                    const isSelected = selected.includes(value);

                    return (
                        <ListItemButton
                            disabled={disabled}
                            key={value.id}
                            role="listitem"
                            onClick={(event) => handleItemClick(event, value, index, items)}
                            selected={isSelected}
                            sx={{
                                // Cor de fundo mais forte quando selecionado
                                bgcolor: isSelected ? "#1976d2" : "transparent",
                                color: isSelected ? "#fff" : "inherit",
                                "&:hover": {
                                    bgcolor: isSelected ? "#1565c0" : "action.hover",
                                },
                                "&.Mui-selected:hover": {
                                    bgcolor: "#1565c0",
                                },
                                "&.Mui-selected": {
                                    bgcolor: "#002444",
                                },
                                transition: "background-color 0.2s ease",
                            }}
                        >
                            <ListItemText
                                disabled={disabled}
                                id={labelId}
                                primary={
                                    value.dataPersonal?.nameFantasy ||
                                    value.dataPersonal?.socialName ||
                                    value.socialName ||
                                    value.name
                                }
                            />
                        </ListItemButton>
                    );
                })}
            </List>
        </Paper>
    );

    const handleAllRight = () => {
        const newRight = [...right, ...left]; // cria o novo array corretamente antes de atualizar o estado
        setRight(newRight);
        setLeft([]); // limpa o lado esquerdo
        if (typeof onChange === "function") {
            onChange(newRight.map(shipper => shipper.id));
        }
    };

    // const handleCheckedRight = () => {
    //     setRight(right.concat(leftChecked));
    //     let newRight = right.concat(leftChecked);
    //     setLeft(not(left, leftChecked));
    //     setChecked(not(checked, leftChecked));
    //     if (typeof onChange === "function") {
    //         onChange(newRight.map(shipper => shipper.id));
    //     }
    // };
    const handleCheckedRight = () => {
        setRight(right.concat(leftChecked));
        const newRight = right.concat(leftChecked);
        setLeft(not(left, leftChecked));
        setSelected(not(selected, leftChecked)); // limpa seleção
        if (typeof onChange === "function") {
            onChange(newRight.map((shipper) => shipper.id));
        }
    };

    // const handleCheckedLeft = () => {
    //     setLeft(left.concat(rightChecked));
    //     setRight(not(right, rightChecked));
    //     let newRight = not(right, rightChecked);
    //     setChecked(not(checked, rightChecked));
    //     if (typeof onChange === "function") {
    //         onChange(newRight.map(shipper => shipper.id));
    //     }
    // };

    const handleCheckedLeft = () => {
        setLeft(left.concat(rightChecked));
        const newRight = not(right, rightChecked);
        setRight(newRight);
        setSelected(not(selected, rightChecked));
        if (typeof onChange === "function") {
            onChange(newRight.map((shipper) => shipper.id));
        }
    };

    const handleAllLeft = () => {
        setLeft(left.concat(right));
        setRight([]);
        if (typeof onChange === "function") {
            onChange([]);
        }
    };

    // const customList = (items) => (
    //     <Paper sx={{ width: "auto", height: 300, overflow: "auto" }}>
    //         <List disabled={disabled} dense component="div" role="list">
    //             {items.map((value) => {
    //                 const labelId = `transfer-list-item-${value}-label`;

    //                 return (
    //                     <ListItemButton
    //                         disabled={disabled}
    //                         key={value}
    //                         role="listitem"
    //                         onClick={handleToggle(value)}
    //                     >
    //                         <ListItemIcon>
    //                             <Checkbox
    //                                 sx={{ display: "none" }}
    //                                 disabled={disabled}
    //                                 checked={checked.includes(value)}
    //                                 tabIndex={-1}
    //                                 disableRipple
    //                                 inputProps={{
    //                                     "aria-labelledby": labelId,
    //                                 }}
    //                             />
    //                         </ListItemIcon>
    //                         <ListItemText disabled={disabled} id={labelId} primary={value.dataPersonal?.socialName || value.socialName || value.name} />
    //                     </ListItemButton>
    //                 );
    //             })}
    //         </List>
    //     </Paper>
    // );

    const handleItemClick = (event, value, index, items) => {
        if (event.shiftKey) {
            // Seleção em intervalo (Shift)
            const lastSelected = selected[selected.length - 1];
            const lastIndex = items.findIndex((item) => item === lastSelected);
            const start = Math.min(index, lastIndex);
            const end = Math.max(index, lastIndex);
            const range = items.slice(start, end + 1);
            setSelected((prev) => Array.from(new Set([...prev, ...range])));
        } else if (event.ctrlKey || event.metaKey) {
            // Seleção múltipla (Ctrl/Cmd)
            setSelected((prev) =>
            prev.includes(value)
                ? prev.filter((v) => v !== value)
                : [...prev, value]
            );
        } else {
            // Seleção única
            setSelected([value]);
        }
    };

    return (
        <Grid container justifyContent="center" alignItems="center" columnSpacing={0}>
            <Grid item sx={{ mx: 1 }}>
                <Typography sx={{ mb: 1, fontWeight: 'bold' }} variant="subtitle2" noWrap>Embarcadores Disponíveis</Typography>
                {customList(left)}
            </Grid>

            <Grid item>
                <Grid container direction="column" alignItems="center">
                    <Button
                        sx={{ my: 0.5 }}
                        variant="outlined"
                        size="small"
                        onClick={handleAllRight}
                        disabled={disabled || left.length === 0}
                        aria-label="move all right"
                    >
                        ≫
                    </Button>
                    <Button
                        sx={{ my: 0.5 }}
                        variant="outlined"
                        size="small"
                        onClick={handleCheckedRight}
                        disabled={disabled || leftChecked.length === 0}
                        aria-label="move selected right"
                    >
                        &gt;
                    </Button>
                    <Button
                        sx={{ my: 0.5 }}
                        variant="outlined"
                        size="small"
                        onClick={handleCheckedLeft}
                        disabled={disabled || rightChecked.length === 0}
                        aria-label="move selected left"
                    >
                        &lt;
                    </Button>
                    <Button
                        sx={{ my: 0.5 }}
                        variant="outlined"
                        size="small"
                        onClick={handleAllLeft}
                        disabled={disabled || right.length === 0}
                        aria-label="move all left"
                    >
                        ≪
                    </Button>
                </Grid>
            </Grid>

            <Grid item sx={{ mx: 1 }}>
                <Typography sx={{ mb: 1, fontWeight: 'bold' }} variant="subtitle2" noWrap>Embarcadores Selecionados</Typography>
                {customList(right)}
            </Grid>
        </Grid>
    );
}
